import axios from "axios";
import get from "lodash.get";
import { getConfig } from "../config";
import delay from "./delay";
import { isValid } from "./jwt";
const api = axios.create();
var api_default = api;
const requestInterceptor = (request) => {
  request = {
    baseURL: getConfig().API_URL,
    ...request
  };
  return request;
};
const tokenInterceptor = (request) => {
  const token = localStorage.getItem("token");
  if (token && isValid(token)) {
    request = {
      baseURL: getConfig().API_URL,
      ...request,
      headers: {
        ...request.headers,
        Authorization: `Bearer ${token}`
      }
    };
  }
  return request;
};
const cacheBusterInterceptor = (request) => {
  if (request.method === "get") {
    request = {
      ...request,
      params: {
        ...request.params,
        _bust: (/* @__PURE__ */ new Date()).getTime()
      }
    };
  }
  return request;
};
const responseTypeInterceptor = async (response) => {
  const {
    data: { type },
    config: { responseDataPath, ...config }
  } = response;
  const path = responseDataPath || "data.data";
  const responseData = get(response, path);
  switch (type) {
    case "response_ready":
      return responseData;
    case "saga":
      return handleSAGA(responseData, config);
    default:
      return response.data;
  }
};
const handleResponseError = (error) => Promise.reject(error);
const handleSAGA = async ({ link }, { whilePending }) => {
  const api2 = axios.create();
  api2.interceptors.request.use(cacheBusterInterceptor);
  let response;
  try {
    response = await api2.get(link);
  } catch (e) {
    if (!e.response && !navigator.onLine) {
      await new Promise((resolve) => {
        window.addEventListener("online", () => {
          resolve();
        });
      });
      return handleSAGA({ link }, { whilePending });
    } else {
      throw e;
    }
  }
  const saga = get(response, "data.data.saga", {});
  const { generalStatus, status, message } = saga;
  if (status === "failed" && generalStatus === "failed") {
    const error = new Error(message);
    error.response = saga;
    error.type = "saga";
    return handleResponseError(error);
  } else if (["failed", "completed"].includes(generalStatus)) {
    return saga;
  } else if (whilePending) {
    return whilePending(saga, () => handleSAGA({ link }, { whilePending }));
  } else {
    await delay(250);
    return handleSAGA({ link }, { whilePending });
  }
};
api.interceptors.request.use(requestInterceptor);
api.interceptors.request.use(tokenInterceptor);
api.interceptors.request.use(cacheBusterInterceptor);
api.interceptors.response.use(responseTypeInterceptor, handleResponseError);
export {
  api_default as default
};
